<template>
    <li title="Загрузить список ИНН, ОГРН или ОКПО" class="search-load">
        <i @click="modalClick" class="lnr lnr-text-align-justify"></i>

        <div class="search-list" v-if="modalDisplay">
            <h6>Загрузка кодов для формирования списка</h6>

            <div class="search-list-holder">
                <textarea v-model="idlist" placeholder="ИНН, ОГРН или ОКПО, не более 500 кодов, каждый с новой строки"></textarea>
            </div>

            <div @click="uploadHandle" class="search-list-submit" style="margin-top: 40px;">Найти по списку</div>
            <div @click="modalClick" class="search-list-close" style="color: #c00; cursor: pointer; margin-top: 20px;">&times; Закрыть</div>
        </div>
    </li>
</template>

<script>
export default {
    data() {
        return {
            modalDisplay: false
        }
    },
    methods: {
        uploadHandle() {
            this.modalClick()
            this.$store.dispatch('search/getCards')
        },
        modalClick() {
            this.modalDisplay = !this.modalDisplay
        },
        escPress(e){
            const code = e.keyCode || e.which
            if(code == 27) {
                this.modalDisplay = false
            }
        }
    },
    mounted() {
        document.body.addEventListener('keydown', this.escPress)
    },
    computed: {
        idlist: {
            get() { return this.$store.state.search.idlist },
            set(value) { this.$store.commit('search/updateSearchObject', { obj: 'idlist', value }) }
        }
    }
}
</script>

<style scoped>
.search-list {
    text-align: center;
	position: fixed; width: 100%; height: 100%; top: 0; left: 0;
	z-index: 11000;
	background: rgba(255,255,255,1.0);
}

.search-list h6 {
	margin: 0; padding: 0;
	display: inline-block; font-family: 'PT Serif', serif; font-size: 40px; text-align: center; padding-top: 100px; padding-bottom: 50px; max-width: 1000px; line-height: 48px;
	
}

.search-list-holder {
	padding: 0 20px;
}

.search-list-holder textarea {
	margin: 0; padding: 0;
	display: block; 
	width: 100%; max-width: 1000px;
	height: 50vh;
	margin: 0 auto;
	padding: 20px;
	font-family: Helvetica, Arial, sans-serif; font-size: 20px;
}

.search-list-submit {
	display: inline-block;
	background: #F5D76E;
	padding: 10px 20px; margin-top: 20px;
	font-size: 24px; font-weight: 700;
	border-radius: 4px;
	cursor: pointer;	
}
</style>
